module.exports = __webpack_public_path__ + "static/media/igra_thumb_even.354ec94b.jpg";